import { render } from "./ModalConfirmar.vue?vue&type=template&id=724d0e8f"
import script from "./ModalConfirmar.vue?vue&type=script&lang=js"
export * from "./ModalConfirmar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\repos\\excurix\\src\\UI\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__